module.exports = __webpack_public_path__ + "static/media/KTH_Logo.8c5ac0b2.png";